var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1686,
    height: 1186,
    viewBox: "0 0 1686 1186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M603.102 751.338L706.125 810.735L949.288 669.662L842.556 610.265L603.102 751.338Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M603.102 1065.03L706.125 1124.43L949.288 983.363L842.556 923.966L603.102 1065.03Z",
    stroke: "#231F20",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M603.691 1065.03L706.714 1124.43L949.867 983.363L843.146 923.966L603.691 1065.03Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M706.125 810.735V1124.42",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M841.625 610.265V923.965L949.18 983.251V669.562",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M603.102 750.306V1064",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M603.102 919.888L706.125 979.285L949.288 838.212L842.556 778.814L603.102 919.888Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M603.691 1065.03L706.714 1124.42L949.867 983.362L843.146 923.965L603.691 1065.03Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M706.125 979.285V1124.43",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M603.102 918.855V1067.76",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M704.816 979.464L807.839 1038.86L1051 897.788L944.271 838.391L704.816 979.464Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M705.406 1124.6L808.429 1184L1051.58 1042.94L944.86 983.541L705.406 1124.6Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M807.84 1038.86V1184",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.04 896.466V1041.6",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M704.816 978.432V1127.34",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M481.832 748.539L378.82 807.947L135.656 666.874L242.389 607.477L481.832 748.539Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M481.832 1062.24L378.82 1121.64L135.656 980.563L242.389 921.166L481.832 1062.24Z",
    stroke: "#231F20",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M481.253 1062.24L378.23 1121.64L135.066 980.563L241.799 921.166L481.253 1062.24Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M378.816 807.947V1121.64",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M243.312 607.477V921.166L135.758 980.463V666.774",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M481.828 747.518V1061.21",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "8.04 8.04"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3 749.883L106.023 809.28L349.187 668.207L242.454 608.81L3 749.883Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1063.57L106.023 1122.98L349.187 981.908L242.454 922.511L3 1063.57Z",
    stroke: "#231F20",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58984 1063.57L106.613 1122.98L349.766 981.908L243.044 922.511L3.58984 1063.57Z",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M106.023 809.28V1122.98",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M241.523 608.81V922.51L349.078 981.807V668.107",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3 748.851V1062.55",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1219 1V1101",
    stroke: "white",
    strokeWidth: 2.32124,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1311 0V1101",
    stroke: "white",
    strokeWidth: 2.32124,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1401 7V1101",
    stroke: "white",
    strokeWidth: 2.31013,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1485 1V1101",
    stroke: "white",
    strokeWidth: 2.32124,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1575 1V1101",
    stroke: "white",
    strokeWidth: 2.32124,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1659 0V1101",
    stroke: "white",
    strokeWidth: 2.32124,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.98 1031.8C1234.1 1031.8 1245.55 1020.35 1245.55 1006.22C1245.55 992.093 1234.1 980.642 1219.98 980.642C1205.85 980.642 1194.4 992.093 1194.4 1006.22C1194.4 1020.35 1205.85 1031.8 1219.98 1031.8Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.06 940.259C1324.18 940.259 1335.64 928.807 1335.64 914.681C1335.64 900.554 1324.18 889.103 1310.06 889.103C1295.93 889.103 1284.48 900.554 1284.48 914.681C1284.48 928.807 1295.93 940.259 1310.06 940.259Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1400.16 693.241C1414.28 693.241 1425.73 681.789 1425.73 667.663C1425.73 653.537 1414.28 642.085 1400.16 642.085C1386.03 642.085 1374.58 653.537 1374.58 667.663C1374.58 681.789 1386.03 693.241 1400.16 693.241Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1574.51 789.134C1588.64 789.134 1600.09 777.682 1600.09 763.556C1600.09 749.429 1588.64 737.978 1574.51 737.978C1560.39 737.978 1548.93 749.429 1548.93 763.556C1548.93 777.682 1560.39 789.134 1574.51 789.134Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1482.98 745.552C1497.1 745.552 1508.55 734.1 1508.55 719.974C1508.55 705.847 1497.1 694.396 1482.98 694.396C1468.85 694.396 1457.4 705.847 1457.4 719.974C1457.4 734.1 1468.85 745.552 1482.98 745.552Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1658.79 915.547C1672.92 915.547 1684.37 904.095 1684.37 889.969C1684.37 875.842 1672.92 864.391 1658.79 864.391C1644.66 864.391 1633.21 875.842 1633.21 889.969C1633.21 904.095 1644.66 915.547 1658.79 915.547Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.98 1006.22L1310.06 914.68L1400.16 667.662L1575.24 770.83L1658.79 889.968",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.98 770.83L1310.06 679.279L1397.97 556.498L1575.24 613.174L1658.79 654.579",
    stroke: "white",
    strokeWidth: 2.90988,
    strokeMiterlimit: 10,
    strokeDasharray: "6.66 6.66"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.98 796.408C1234.1 796.408 1245.55 784.956 1245.55 770.83C1245.55 756.704 1234.1 745.252 1219.98 745.252C1205.85 745.252 1194.4 756.704 1194.4 770.83C1194.4 784.956 1205.85 796.408 1219.98 796.408Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.45494,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.06 704.858C1324.18 704.858 1335.64 693.407 1335.64 679.28C1335.64 665.154 1324.18 653.702 1310.06 653.702C1295.93 653.702 1284.48 665.154 1284.48 679.28C1284.48 693.407 1295.93 704.858 1310.06 704.858Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.45494,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1397.97 582.077C1412.1 582.077 1423.55 570.625 1423.55 556.499C1423.55 542.373 1412.1 530.921 1397.97 530.921C1383.84 530.921 1372.39 542.373 1372.39 556.499C1372.39 570.625 1383.84 582.077 1397.97 582.077Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.45494,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1575.24 638.752C1589.36 638.752 1600.82 627.3 1600.82 613.174C1600.82 599.047 1589.36 587.596 1575.24 587.596C1561.11 587.596 1549.66 599.047 1549.66 613.174C1549.66 627.3 1561.11 638.752 1575.24 638.752Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.45494,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1482.24 612.597C1496.37 612.597 1507.82 601.145 1507.82 587.018C1507.82 572.892 1496.37 561.44 1482.24 561.44C1468.12 561.44 1456.66 572.892 1456.66 587.018C1456.66 601.145 1468.12 612.597 1482.24 612.597Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.45494,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1658.79 680.157C1672.92 680.157 1684.37 668.705 1684.37 654.579C1684.37 640.453 1672.92 629.001 1658.79 629.001C1644.66 629.001 1633.21 640.453 1633.21 654.579C1633.21 668.705 1644.66 680.157 1658.79 680.157Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.45494,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.a5b835e682321bd38cfac334ebf2d6b5.svg";
export { ForwardRef as ReactComponent };